import { render, staticRenderFns } from "./PageContentHeader.vue?vue&type=template&id=7e2875cb&scoped=true"
import script from "./PageContentHeader.vue?vue&type=script&lang=js"
export * from "./PageContentHeader.vue?vue&type=script&lang=js"
import style0 from "./PageContentHeader.vue?vue&type=style&index=0&id=7e2875cb&prod&lang=scss&scoped=true"
import style1 from "./PageContentHeader.vue?vue&type=style&index=1&id=7e2875cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2875cb",
  null
  
)

export default component.exports